var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "multi-chat-viewer",
      on: {
        click: function (e) {
          return _vm.onSingleChatClicked(e)
        },
      },
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(
                _vm._s(_vm.$t("auto.chatsOn")) +
                  " " +
                  _vm._s(_vm.getSelectedAgentName())
              ),
            ]),
            _vm._v(" "),
            _c("CircleUserSelect", {
              attrs: {
                users: _vm.getChatUsers(),
                value: _vm.multiChatView.type,
              },
              on: { input: _vm.changeAgentGroup },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.close } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.close")) +
                    "\n                "
                ),
                _c("span", { staticClass: "shortcut-keyboard dark" }, [
                  _vm._v(_vm._s(_vm.$t("search.keyboardEsc"))),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.selectionMode
        ? _c("div", { staticClass: "selection-bar" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.selectedContacts.length) +
                  " " +
                  _vm._s(_vm.$t("auto.chatSelected"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c(
                  "SupsisButton",
                  { attrs: { ghost: "" }, on: { click: _vm.selectAllChats } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("select_all"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.selectAllPermission")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "shortcut-keyboard dark" }, [
                      _vm._v(_vm._s(_vm.isMac ? "⌘A" : "Alt+A")),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("SupsisButton", { on: { click: _vm.closeSelectedChats } }, [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("stop")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.speechTermination")) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "shortcut-keyboard dark" }, [
                    _vm._v(_vm._s(_vm.isMac ? "⌘S" : "Alt+S")),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { on: { click: _vm.redirectSelectedChats } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("forward"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.forwardRep")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "shortcut-keyboard dark" }, [
                      _vm._v(_vm._s(_vm.isMac ? "⌘Y" : "Alt+Y")),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("SupsisButton", { on: { click: _vm.assignSelectedChats } }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("person_add"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.addRepresentative")) +
                      "\n                "
                  ),
                  _c("span", { staticClass: "shortcut-keyboard dark" }, [
                    _vm._v(_vm._s(_vm.isMac ? "⌘E" : "Alt+T")),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { danger: "" }, on: { click: _vm.cancelSelection } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("cancel"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.cancel")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "shortcut-keyboard dark" }, [
                      _vm._v(_vm._s(_vm.isMac ? "⌘V" : "Alt+V")),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "chatsScrollContent", staticClass: "chats" },
        [
          _vm._l(_vm.getContacts(), function (contact) {
            return _c(
              "div",
              {
                key: contact.id,
                staticClass: "single-chat",
                class: { focused: _vm.focusedContact === contact._id },
                on: {
                  click: function (e) {
                    return _vm.onSingleChatClicked(e, contact)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "single-chat-header",
                    on: {
                      mouseenter: _vm.onHeaderMouseEnter,
                      mouseleave: _vm.onHeaderMouseLeave,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "left",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleSelectContact(contact)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "select-icon" }, [
                          _c("div", { staticClass: "circle-icon" }, [
                            !_vm.isHovered && !_vm.selectionMode
                              ? _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("person"),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass: "circle-checkbox",
                                    class: {
                                      "is-checked":
                                        _vm.isContactSelected(contact),
                                    },
                                  },
                                  [
                                    _vm.isContactSelected(contact)
                                      ? _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(contact.fullname))]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { ghost: "", small: "" },
                            on: {
                              click: function () {
                                return _vm.showProfile(contact)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("info"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("auto.profile")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showingProfileContactId === contact._id &&
                _vm.focusedContact === contact._id
                  ? _c(
                      "div",
                      { staticClass: "contact-detail-wrapper" },
                      [
                        _c("ContactDetail", {
                          attrs: {
                            contact: contact,
                            "show-profile-top": false,
                          },
                        }),
                        _vm._v(" "),
                        _c("a-divider"),
                        _vm._v(" "),
                        _c("ContactProperties", {
                          attrs: { contact: contact, "show-toolbar": false },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("ChatWindow", {
                  ref: "chatWindow",
                  refInFor: true,
                  style: { width: _vm.chatWindowWidth },
                  attrs: {
                    "is-live": true,
                    contact: contact,
                    "show-header": false,
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.getContacts().length === 0
            ? _c("div", { staticClass: "empty" }, [
                _c("h1", [_vm._v(_vm._s(_vm.$t("auto.noChatFound")))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("auto.noChatForThisAgent")))]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.assignAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "assign-agent",
                title: _vm.$t("message.addRepresentative"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.assignAgent = false
                },
              },
            },
            [
              _c("AgentList", {
                attrs: {
                  assign: true,
                  "show-online-agents": true,
                  "default-contacts": _vm.selectedContacts,
                },
                on: {
                  close: function () {
                    return _vm.closeModal("assign")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.forwardAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "forward-agent",
                title: _vm.$t("message.forwardRepresentative"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.forwardAgent = false
                },
              },
            },
            [
              _c("AgentList", {
                attrs: {
                  forward: true,
                  "show-online-agents": true,
                  "default-contacts": _vm.selectedContacts,
                },
                on: {
                  close: function () {
                    return _vm.closeModal("forward")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }